import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

import datetimeHelper from "../../helper/datetime-helper";

const PackageInfo = ({ packageInfo }) => {
  return (
    <Grid
      container
      spacing={24}
      style={{ marginTop: 3, marginBottom: 3, padding: 20 }}>
      <Grid
        item
        md={3}
        xs={12}
        style={{
          borderLeft: "1px solid #eee",
          borderRight: "1px solid #eee",
          borderTop: "1px solid #eee",
        }}>
        <h5 style={{ fontSize: 18, color: "red" }}>Thông tin người gửi</h5>
        <InfoField
          title="Tên người gửi"
          value={packageInfo?.info?.ten_nguoi_gui || ""}
        />
        <InfoField
          title="Số điện thoại"
          value={packageInfo?.info?.sdt_nguoi_gui || ""}
        />
        <InfoField
          title="Địa chỉ gửi"
          value={packageInfo?.info?.dia_chi_gui || ""}
        />
        <h5 style={{ fontSize: 18, color: "red", marginTop: 9 }}>
          Thông tin người nhận
        </h5>
        <InfoField
          title="Tên người nhận"
          value={packageInfo?.info?.ten_nguoi_nhan || ""}
        />
        <InfoField
          title="Số điện thoại"
          value={packageInfo?.info?.sdt_nguoi_nhan || ""}
        />
        <InfoField
          title="Địa chỉ nhận"
          value={packageInfo?.info?.dia_chi_nhan || ""}
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
        style={{
          borderLeft: "1px solid #eee",
          borderRight: "1px solid #eee",
          borderTop: "1px solid #eee",
        }}>
        <h5 style={{ fontSize: 18, color: "red" }}>Thông tin bưu gửi</h5>
        <InfoField title="Nội dung" value={packageInfo?.info?.noi_dung || ""} />
        <InfoField
          title="Dịch vụ GTGT(VAS)"
          value={packageInfo?.info?.dich_vu_vas || ""}
        />
        <InfoField title="COD" value={packageInfo?.info?.cod || ""} />
        <InfoField title="Tiền COD" value={packageInfo?.info?.tien_cod || ""} />
        <InfoField
          title="Bưu cục gửi"
          value={packageInfo?.info?.buu_cuc_gui || ""}
        />
        <InfoField
          title="Vị trí"
          value={packageInfo?.info?.buu_cuc_phat || ""}
        />
        <InfoField
          title="Ngày cấp nhận"
          value={
            packageInfo?.info?.ngay_nhan
              ? datetimeHelper.toFormat(
                  packageInfo.info.ngay_nhan,
                  "YYYY-MM-DD HH:mm:ss"
                )
              : ""
          }
        />
        <InfoField
          title="Khối lượng"
          value={
            packageInfo?.info?.khoi_luong
              ? `${packageInfo?.info?.khoi_luong} (g)`
              : ""
          }
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
        style={{
          borderTop: "1px solid #eee",
          borderRight: "1px solid #eee",
        }}>
        <h5 style={{ fontSize: 18, color: "red" }}>Thông tin phát</h5>
        <InfoField
          title="Trạng thái"
          value={packageInfo?.phat?.trang_thai || ""}
        />
        <InfoField
          title="Bưu cục phát"
          value={packageInfo?.phat?.vi_tri || ""}
        />
        <InfoField
          title="Ngày nhập"
          value={packageInfo?.phat?.ngay_nhap || ""}
        />
        <InfoField
          title="Ngày phát"
          value={packageInfo?.phat?.ngay_phat || ""}
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
        style={{
          borderRight: "1px solid #eee",
          borderTop: "1px solid #eee",
        }}>
        <h5 style={{ fontSize: 18, color: "red" }}>Thông tin bưu tá</h5>
        <InfoField
          title="Tên bưu tá gom"
          value={packageInfo?.postman?.ten_buu_ta_gom || ""}
        />
        <InfoField
          title="Số điện thoại bưu tá gom"
          value={packageInfo?.postman?.sdt_buu_ta_gom || ""}
        />
        <InfoField
          title="Tên bưu tá phát"
          value={packageInfo?.postman?.ten_buu_ta_phat || ""}
        />
        <InfoField
          title="Số điện thoại bưu tá phát"
          value={packageInfo?.postman?.sdt_buu_ta_phat || ""}
        />
      </Grid>

      <Grid item md={12} style={{ border: "1px solid #eee" }}>
        <h5 style={{ fontSize: 18, color: "red" }}>Thông tin định vị</h5>
        <Table>
          <TableHead>
            <TableCell>Ngày</TableCell>
            <TableCell>Giờ</TableCell>
            <TableCell>Trạng thái</TableCell>
            <TableCell>Vị trí</TableCell>
          </TableHead>
          <TableBody>
            {packageInfo?.dinhvi?.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.ngay}</TableCell>
                <TableCell>{item.gio}</TableCell>
                <TableCell>
                  {item.trang_thai} - {item.text_trang_thai}
                </TableCell>
                <TableCell>{item.vi_tri}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
};

const InfoField = ({ title, value }) => (
  <div style={{ marginBottom: 3 }}>
    <span style={{ fontWeight: 600 }}>{title}</span>: <span>{value}</span>
  </div>
);

export default PackageInfo;
